import React, { useContext } from 'react';
import { Typography } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import { ApplicationUIContext, Table } from '@yuhuinc/ui-library';
import { CurrentApplicationContext } from '../../ApplicationOverview';

const translate = (key) =>
  getTranslatedString(`landlordPortal.applicationManagement.leaseOverview.${key}`);

const { Title } = Typography;

const COLUMNS = [
  {
    title: translate('overview.documents.name'),
    dataIndex: 'name',
    width: '64%',
  },
  {
    title: translate('overview.documents.signers'),
    dataIndex: 'signers',
  },
  {
    title: translate('overview.documents.sent'),
    dataIndex: 'sent',
  },
];

const Documents = () => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <>
      <Title level={isMobile ? 4 : 5}>{translate('overview.documents')}</Title>
      <Table
        size="small"
        hideActionAndSearch
        columns={COLUMNS}
        dataSource={[]}
        rowKey="id"
        pagination={false}
      />
    </>
  );
};

export default Documents;
